export default __webpack_public_path__ + "static/media/Chevron.1047cbaa.svg";